'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("AadCompteEditionPopinController", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  $http.get('/rest/intra/utilisateurs/consultants').then(function (response) {
    $scope.consultants = _.sortBy(response.data, function (consultant) {
      return consultant.label;
    });
  });

  // modification d'une aad existante
  if ($scope.aadId) {
    $http.get("/rest/intra/crm/aad/" + $scope.aadId).then(function (response) {
      console.log("aad", response);
      $scope.aad = response.data;
    });
  }
  $scope.aadFormConfig = {
    url: function url() {
      return '/rest/intra/crm/aad/save';
    },
    data: function data() {
      return $scope.aad;
    },
    customValidation: function customValidation() {
      return [];
    },
    fieldPrefix: "aad.",
    onSuccess: function onSuccess(aad) {
      $scope.$close(aad);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/aad/edition/aadCompteEditionPopin.js
// module id = 2676
// module chunks = 13